/**
 * 模态框配置（合并原 modalConfig.ts）
 */

// 创建权限模态框配置
export const createModalConfig = {
  title: "创建权限",
  width: 600,
  height: "auto",
  okText: "确定",
  cancelText: "取消",
  layout: "horizontal" as const,
  labelCol: { span: 6 },
  wrapperCol: { span: 18 },
  modalProps: {
    destroyOnClose: true,
    width: 600,
  },
};

// 编辑权限模态框配置
export const editModalConfig = {
  title: "编辑权限",
  width: 600,
  height: "auto",
  okText: "确定",
  cancelText: "取消",
  layout: "horizontal" as const,
  labelCol: { span: 6 },
  wrapperCol: { span: 18 },
  modalProps: {
    destroyOnClose: true,
    width: 600,
  },
};

// 表单项配置 Hook（合并自 permissionFormConfig.tsx）
import type { FormItemConfig } from "@ms/shared-components/comps/CompsForm";
import { usePermissionEnums } from "../hooks/usePermissionEnums";

export const usePermissionFormConfig = () => {
  const { serviceOptionsForForm, actionOptions, statusOptions } = usePermissionEnums();

  // 创建表单配置：只需要微服务和页面名称
  const getCreateFormConfig = (): FormItemConfig[] => [
    {
      name: "serviceName",
      label: "微服务",
      type: "select",
      rules: [{ required: true, message: "请选择微服务" }],
      props: {
        placeholder: "请选择微服务",
        options: serviceOptionsForForm,
      },
    },
    {
      name: "page",
      label: "页面名称",
      type: "input",
      rules: [{ required: true, message: "请输入页面名称" }],
      props: {
        placeholder: "请输入页面名称（英文）",
      },
    },
  ];

  const getEditFormConfig = (): FormItemConfig[] => [
    {
      name: "name",
      label: "权限名称",
      type: "input",
      rules: [{ required: true, message: "请输入权限名称" }],
      props: {
        placeholder: "请输入权限名称",
      },
    },
    {
      name: "description",
      label: "权限描述",
      type: "textarea",
      props: {
        placeholder: "请输入权限描述",
        rows: 3,
      },
    },
    {
      name: "serviceName",
      label: "微服务",
      type: "select",
      rules: [{ required: true, message: "请选择微服务" }],
      props: {
        placeholder: "请选择微服务",
        options: serviceOptionsForForm,
      },
    },
    {
      name: "page",
      label: "页面",
      type: "input",
      rules: [{ required: true, message: "请输入页面名称" }],
      props: {
        placeholder: "请输入页面名称",
      },
    },
    {
      name: "action",
      label: "操作",
      type: "select",
      rules: [{ required: true, message: "请选择操作" }],
      props: {
        placeholder: "请选择操作",
        options: actionOptions,
      },
    },
    {
      name: "isActive",
      label: "状态",
      type: "select",
      rules: [{ required: true, message: "请选择状态" }],
      props: {
        placeholder: "请选择状态",
        options: statusOptions,
      },
    },
  ];

  return {
    getCreateFormConfig,
    getEditFormConfig,
  };
};


